(() => {
  const HUBSPOT_PORTAL_ID = '244453579';
  const HUBSPOT_FORM_GUID = '7628b5b0-9a01-4bc2-bc4c-0b0f3b53ee3f';
  const HUBSPOT_ENDPOINT = `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_PORTAL_ID}/${HUBSPOT_FORM_GUID}`;

  // Maps this form's field names (as they appear in contact[Field Name]) to
  // HubSpot's internal property names.
  const FIELD_MAP = {
    'First name': 'firstname',
    'Last name': 'lastname',
    'email': 'email',
    'Phone number': 'phone',
    'Preferred communication method': 'preferred_communication_method',
    'Reason for contact': 'contact_reason',
    'body': 'inquiry_reason', // the "Message" textarea uses Shopify's contact[body] convention
  };

  // "Reason for contact" is a merchant-editable dropdown in the theme
  // editor, but HubSpot's contact_reason property is a fixed picklist that
  // only accepts its own internal values, not arbitrary display text. This
  // translates the current on-site wording to what HubSpot expects.
  const REASON_VALUE_MAP = {
    'I have a question before purchasing': 'I have a question before purchasing',
    'I need help with my device or app': 'I need help with my device or app',
    'I have a question about my order': 'Order question',
    'Something else': 'Something else',
  };

  function getHubspotCookie() {
    const match = document.cookie.match(/(?:^|;\s*)hubspotutk=([^;]+)/);
    return match ? match[1] : undefined;
  }

  function buildHubspotPayload(form) {
    const formData = new FormData(form);
    const fields = [];

    formData.forEach((value, key) => {
      const match = key.match(/^contact\[(.+)\]$/);
      if (!match) return;

      const fieldName = match[1];
      const hubspotName = FIELD_MAP[fieldName];
      if (!hubspotName || value === '') return;

      let submitValue = value.toString();

      if (fieldName === 'Reason for contact') {
        const mapped = REASON_VALUE_MAP[submitValue];
        // If the theme editor's option text ever changes and no longer
        // matches our map, skip the field instead of sending a value
        // HubSpot will reject.
        if (!mapped) return;
        submitValue = mapped;
      }

      fields.push({ name: hubspotName, value: submitValue });
    });

    const payload = {
      fields,
      context: {
        pageUri: window.location.href,
        pageName: document.title,
      },
    };

    const hutk = getHubspotCookie();
    if (hutk) payload.context.hutk = hutk;

    return payload;
  }

  function sendToHubspot(form) {
    const payload = buildHubspotPayload(form);

    // keepalive lets this request outlive the page navigation triggered by
    // the native Shopify form submit, similar to sendBeacon. Unlike
    // sendBeacon, fetch lets us control the credentials mode explicitly.
    // sendBeacon always sends cross-origin requests with credentials
    // included, and HubSpot's endpoint doesn't return
    // Access-Control-Allow-Credentials: true, so that request gets blocked
    // by the browser. Omitting credentials here avoids that entirely.
    fetch(HUBSPOT_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'omit',
      keepalive: true,
    }).catch(() => {
      // Intentionally silent. A failed HubSpot sync shouldn't block or
      // change Shopify's own contact form submission and success state.
    });
  }

  document.querySelectorAll('form[id^="cf-form-"]').forEach((form) => {
    form.addEventListener('submit', () => {
      // No preventDefault here. Shopify's native submission runs exactly
      // as it did before, this just also mirrors the data to HubSpot.
      sendToHubspot(form);
    });
  });
})();
